export default {
  isFirstLoading: true,
  tabSelected: '0',
  promRequestsModalOpen: false,
  sidebar:{
    allFormModels: true,
    categoryUndefined: false,
    categorySelected: false,
  },
  fetching: {
    listFormModels: false,
    listDrafts: false,
    createFormEmpty: false,
    createDraft: false,
    getCategories: false,
    saveSections: false,
    promRequests: false,
    createPromRequest: false,
    reviewPromRequest: false,
    getPromRequestById: false,
    getPromRequestForm: false,
    updatePromRequestForm: false,
  },
  api: {
    listFormModels: [],
    listDrafts: [],
    listManagerFormModels: [],
    categorySelected: {},
    categoriesAllForms: [],
    categoriesForms: [],
    authors: [],
    listFormModelsDeleted: [],
    listDraftsDeleted: [],
    favorites: {
      formModels: []
    },
    filter:{
      forms: [],
      isFilter: false,
    },
    promRequests: [],
    promRequestSelected: null,
    promRequestForm: null,
  },
};
